<template>
  <div
    :style="
      clientStore.getCustomBackgroundImagePath !== null
        ? 'background-image: url(' +
          clientStore.getCustomBackgroundImagePath +
          '); '
        : ''
    "
    :class="{
      'custom-background-image':
        clientStore.getCustomBackgroundImagePath !== null,
    }"
  >
    <BackgroundBubbles
      v-if="clientStore.getCustomBackgroundImagePath === null"
    />
    <div
      v-if="!showActivatePasswordSet"
      class="m-auto h-screen max-w-7xl flex justify-center align-middle flex-col"
    >
      <div class="text-4xl text-white mx-auto mb-8">
        {{ $t("ssosbk.activation.success.title") }}
      </div>
      <div class="text-xl font-bold mx-auto">
        {{ $t("ssosbk.activation.success.text") }}
      </div>

      <div class="text-xl mx-auto mt-8">
        <div
          class="cursor-pointer mt-2 w-full col-span-2 button-bkk-100 !text-background"
          @click="redirectToLogin()"
        >
          {{ $t("ssosbk.activation.success.button.loginforward.text") }}
        </div>
      </div>

      <div v-if="activationStatusError" class="flex items-center pr-3 mx-auto">
        <ExclamationCircleIcon
          class="h-5 w-5 text-red-800"
          aria-hidden="true"
        />
        <div class="text-xl font-bold text-red-800">
          {{ $t("ssosbk.activation.error.text") }}
        </div>
      </div>
    </div>
    <ActivateSetPassword v-else @on-submit="submitPassword" />
    <FooterLinks bg-fixed />
  </div>
</template>

<script>
import BackgroundBubbles from "../../../components/v2/layout/BackgroundBubbles.vue";
import { sendActivationToken, resendActivation } from "../../../api/sbk";
import { ExclamationCircleIcon } from "@heroicons/vue/solid";
import { useClientStore } from "../../../store/v2/client";
import FooterLinks from "../../../components/v2/sbk/FooterLinks.vue";
import { SBK_BLUE } from "../../../enum/v2/sbk";
import ActivateSetPassword from "../../../components/v2/sbk/ActivateSetPassword.vue";

export default {
  name: "ActivationPage",
  components: {
    ActivateSetPassword,
    FooterLinks,
    ExclamationCircleIcon,
    BackgroundBubbles,
  },
  setup() {
    const clientStore = useClientStore();
    return {
      clientStore,
    };
  },
  data() {
    return {
      client: null,
      activationStatusError: false,
      isResendActivation: false,
      resendLinkMail: null,
      resendMailError: null,
      showActivatePasswordSet: false,
    };
  },
  async mounted() {
    const params = this.$route.params;
    if (params.token) {
      let response = await sendActivationToken(params).catch((error) => {
        if (error.response.status === 426) {
          this.showActivatePasswordSet = true;
        } else {
          this.activationStatusError = error;
        }
      });
    }

    this.client = await this.clientStore.getClient(
      null,
      this.$route.params.slug
    );

    this.clientStore.setClientColorsManually(
      SBK_BLUE,
      SBK_BLUE,
      SBK_BLUE,
      SBK_BLUE,
      SBK_BLUE
    );
  },
  methods: {
    redirectToLogin() {
      this.$router.push({
        name: "sbkLogin",
        params: {
          atmCampaign: this.clientStore.atmCampaign,
        },
      });
    },
    async submitPassword(password) {
      this.activationStatusError = null;
      const params = this.$route.params;

      let response = await sendActivationToken({
        token: params.token,
        password,
      }).catch((error) => {
        this.activationStatusError = error;
      });

      if (response) {
        this.showActivatePasswordSet = false;
      }
    },
  },
};
</script>
